var map = {
	"./Airbnb-is-Expensive–Here-Are-5-Smart-Alternatives-for-Cheaper-Stays/1.jpg": 7511,
	"./Airbnb-is-Expensive–Here-Are-5-Smart-Alternatives-for-Cheaper-Stays/2.jpg": 4936,
	"./How-to-Travel-Without-Paying-for-Hotels/1.jpg": 6854,
	"./How-to-Travel-Without-Paying-for-Hotels/2.jpg": 8993,
	"./This-is-how-home-exchanges-work/1.jpg": 6490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9744;